// Pattern B: HELP_TEXT values are selector functions resolved at the consumer's t scope.
// Consumers translate via t(HELP_TEXT[label]); legitimate use sites bind the pandl ns.
export const HELP_TEXT = {
  Orders: ($) => $.pandl["The total sales amount for orders placed by customers."],
  "Referral Fees": ($) =>
    $.pandl["Fees charged by Amazon for referring a sale, typically a percentage of the sale price."],
  "Refund Referral Fees": ($) =>
    $.pandl["Fees refunded to the seller when a referral fee is reversed due to an order refund."],
  "FBA Per Unit Fulfillment Fee": ($) =>
    $.pandl["Fees charged for order fulfillment services provided by Amazon's Fulfillment by Amazon (FBA) program."],
  "FBA Customer Returns Fee": ($) => $.pandl["Fees for processing customer returns through the FBA program."],
  "Variable Closing Fee": ($) => $.pandl["A fee applied per item sold, varying based on category and item price."],
  "Gift Wrap": ($) => $.pandl["Charges collected from customers for gift wrapping services."],
  "Gift Wrap Chargeback": ($) =>
    $.pandl["Reversal of gift wrap charges, typically due to order cancellations or returns."],
  "FBA Pick & Pack Fee": ($) => $.pandl["Fees for picking and packing items in the FBA warehouse for shipment."],
  "FBA Inbound Placement Service Fee": ($) =>
    $.pandl["Fees for the placement of inbound inventory into Amazon's fulfillment network."],
  "Digital Services Fee": ($) => $.pandl["Fees associated with the sale of digital products or services."],
  "Shipping Fee": ($) => $.pandl["Charges collected from customers for shipping services."],
  "FBA Inbound Transportation Fee": ($) => $.pandl["Fees for transporting inventory to Amazon's fulfillment centers."],
  "Shipping Chargeback": ($) => $.pandl["Reversal of shipping charges, often due to order cancellations or returns."],
  "Return Shipping": ($) => $.pandl["Costs associated with shipping items back to the seller or fulfillment center."],
  "Shipping HB": ($) => $.pandl["Specific shipping-related fees; the exact nature may vary."],
  "FBA Inbound Transportation Program Fee": ($) =>
    $.pandl["Fees for Amazon's program that manages inbound shipping from the seller to fulfillment centers."],
  "Subscription Fee": ($) => $.pandl["Recurring fees for subscribing to Amazon's selling services."],
  "Coupon Redemption Fee": ($) => $.pandl["Fees incurred when customers redeem coupons on seller's products."],
  "Promotion Fee": ($) => $.pandl["Charges for participating in promotional programs to boost product visibility."],
  "Promotion Amount": ($) => $.pandl["The monetary value of promotions applied to orders."],
  Taxes: ($) => $.pandl["Sales tax collected from customers on behalf of tax authorities."],
  "Marketplace Facilitator Tax Principal": ($) =>
    $.pandl["Tax collected and remitted by Amazon as a marketplace facilitator on the principal amount."],
  "Shipping Tax": ($) => $.pandl["Tax collected on shipping charges."],
  "Marketplace Facilitator Tax Shipping": ($) =>
    $.pandl["Tax collected and remitted by Amazon as a marketplace facilitator on shipping charges."],
  "Marketplace Facilitator VAT (Principal)": ($) =>
    $.pandl["Value-added tax collected and remitted by Amazon on the principal amount."],
  "Sales Tax Collection Fee": ($) => $.pandl["Fees associated with the collection and remittance of sales tax."],
  "Low Value Goods Tax (Principal)": ($) => $.pandl["Tax applied to low-value goods on the principal amount."],
  "Gift Wrap Tax": ($) => $.pandl["Tax collected on gift wrap charges."],
  "Marketplace Facilitator Tax (Other)": ($) =>
    $.pandl["Other taxes collected and remitted by Amazon as a marketplace facilitator."],
  "Low Value Goods Tax (Shipping)": ($) => $.pandl["Tax applied to low-value goods on shipping charges."],
  "Marketplace Facilitator VAT (Shipping)": ($) =>
    $.pandl["Value-added tax collected and remitted by Amazon on shipping charges."],
  "Storage Fee": ($) => $.pandl["Charges for storing inventory in Amazon's fulfillment centers."],
  "Warehouse Lost": ($) => $.pandl["Adjustments for inventory lost within the warehouse."],
  "Warehouse Damage": ($) => $.pandl["Adjustments for inventory damaged within the warehouse."],
  "Storage Renewal Billing": ($) => $.pandl["Fees for renewing storage of inventory in fulfillment centers."],
  "Restocking Fee": ($) =>
    $.pandl["Fees charged to the customer when a returned item is subject to a restocking policy."],
  "Missing From Inbound": ($) =>
    $.pandl["Adjustments for items that were expected in inbound shipments but were not received."],
  "Missing From Inbound Clawback": ($) =>
    $.pandl["Reversal of previous reimbursements for missing inbound items upon their subsequent receipt."],
  "Warehouse Damage Exception": ($) => $.pandl["Adjustments related to exceptions in warehouse damage claims."],
  "Inbound Carrier Damage": ($) => $.pandl["Compensation for items damaged during inbound shipping by the carrier."],
  "Warehouse Prep": ($) =>
    $.pandl["Fees for preparation services performed in the warehouse, such as labeling or packaging."],
  "Warehouse Lost Manual": ($) => $.pandl["Manual adjustments for inventory items lost in the warehouse."],
  "Misc Adjustment": ($) =>
    $.pandl["Miscellaneous adjustments to the seller's account not covered by other specific categories."],
  "Service Fee": ($) => $.pandl["Fees charged for various services provided by Amazon."],
  "SAFE-T Reimbursement": ($) =>
    $.pandl[
      "Reimbursements under the Seller Assurance for e-Commerce Transactions (SAFE-T) policy for losses incurred due to claims or chargebacks."
    ],
  "Incorrect Fees Non Itemized": ($) =>
    $.pandl["Adjustments for fees that were incorrectly applied and are not itemized."],
  Goodwill: ($) =>
    $.pandl["Credits or charges made as a gesture of goodwill, often to resolve customer service issues."],
  "Compensated Clawback": ($) =>
    $.pandl["Reversal of previously compensated amounts, typically due to a change in the original decision."],
  "Liquidations Brokerage Fee": ($) =>
    $.pandl["Fees associated with the liquidation of inventory through a brokerage service."],
};
